import { useState, useEffect } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import Spinner from "../../spinner/Spinner";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";

const BranchSalesHistoryDetails = () => {
  const [saleDetails, setSaleDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { saleData } = location.state || {};

  useEffect(() => {
    console.log("sales date is here", saleData);
    if (saleData) {
      setSaleDetails(saleData);
    }
  }, [saleData]);

  const formatDate = (dateString) => {
    if (!dateString) return "Not Available";
    const date = new Date(dateString);
    return date.toLocaleString(); // Formats date and time according to user's locale
  };

  return (
    <MainLayouts>
      <div className="relative sm:rounded-lg py-6 w-full">
        <section className="w-full pr-[3%] pt-3 my-3 bg-gray-100">
          <nav className="bg-gray-200 py-0 px-4 rounded-lg">
            <ol className="list-none p-0 inline-flex mb-2">
              <li className="flex items-center">
                <Link to="/operations/branch/sales" className="text-darkGreen3 pr-2">
                  Sales History
                </Link>
                <ChevronRightIcon />
              </li>
              <li className="flex items-center">
                <p className="text-orange1">Sale Details</p>
              </li>
            </ol>
          </nav>
        </section>

        {loading ? (
          <Spinner loading={loading} />
        ) : saleDetails ? (
          <section className="text-gray-600 body-font">
            <div className="container px-2">
              <div className="flex justify-end mb-3">
                <button
                  onClick={() => navigate(-1)}
                  className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  <span className="flex justify-center sm:justify-start mx-2">
                    <ArrowLeftSquare className="mr-2" />
                    Back
                  </span>
                </button>
              </div>

              <div className="bg-white rounded-lg shadow p-6 mb-6">
                <div className="flex flex-wrap justify-between items-center mb-6 bg-darkGreen3x px-2 py-2">
                  <div>
                    <h5 className=" font-bold text-black2 ">
                      Invoice: {saleDetails.sale.invoice_number}
                    </h5>
                    <p className="text-black2 ">
                      Date: {formatDate(saleDetails.sale.sale_date)}
                    </p>
                  </div>
                  <div className="mt-4 sm:mt-0">
                    <span className={`px-4 py-2 rounded-full text-sm font-semibold ${saleDetails.sale.payment_status === 'paid'
                      ? 'bg-orange1 text-lGrey px-2'
                      : 'bg-dash3 text-lGrey'
                      }`}>
                      {saleDetails.sale.payment_status.toUpperCase()}
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 p-4 rounded-lg ">
                    <h2 className="text-lg font-semibold mb-4 text-gray-700">Customer Information</h2>
                    <p className="mb-2">
                      <span className="font-medium text-gray-600">Name:</span> {saleDetails.sale.customer_name}
                    </p>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h2 className="text-lg font-semibold mb-4 text-gray-700">Order Summary</h2>
                    <p className="mb-2">
                      <span className="font-medium text-gray-600">Total Amount:</span> {CurrencyFormatter(saleDetails.sale.total_amount)}
                    </p>
                  </div>
                </div>

                <div className="mb-8">
                  <h2 className="text-lg font-semibold mb-4 text-gray-700">Products</h2>
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white ">
                      <thead className="bg-darkGreen3">
                        <tr>
                          <th className="py-3 px-4 text-left text-lGrey ">Product</th>
                          <th className="py-3 px-4 text-left  text-lGrey">Category</th>
                          <th className="py-3 px-4 text-left  text-lGrey">Quantity</th>
                          <th className="py-3 px-4 text-left  text-lGrey">Unit Price</th>
                          <th className="py-3 px-4 text-left  text-lGrey">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {saleDetails.items.map((item, index) => (
                          <tr key={index} className={index % 2 === 0 ? 'bg-lGrey' : 'bg-white'}>
                            <td className="py-3 px-4 text-black2">{item.product_name}</td>
                            <td className="py-3 px-4 text-black2">{item.product_category}</td>
                            <td className="py-3 px-4 text-black2">{item.quantity}</td>
                            <td className="py-3 px-4 text-black2">{CurrencyFormatter(item.unit_price)}</td>
                            <td className="py-3 px-4 text-black2">{CurrencyFormatter(item.total_amount)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {saleDetails.items[0]?.note && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h2 className="text-lg font-semibold mb-2 text-gray-700">Notes</h2>
                    <p className="text-gray-600">{saleDetails.items[0].note}</p>
                  </div>
                )}
              </div>
            </div>
          </section>
        ) : (
          <div className="text-center py-10">
            <p className="text-gray-600">No sale details found</p>
            <button
              onClick={() => navigate(-1)}
              className="mt-4 text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5"
            >
              Go Back
            </button>
          </div>
        )}
      </div>
    </MainLayouts>
  );
};

export default BranchSalesHistoryDetails;